import { createSlice } from '@reduxjs/toolkit';
import image1 from '../Assets/PlaceholderImages/1.webp';
import image2 from '../Assets/PlaceholderImages/2.webp';
import image3 from '../Assets/PlaceholderImages/3.webp';
import image4 from '../Assets/PlaceholderImages/4.webp';

const initialState = {
  eventsData: [
    {
      eventTag: 'Tcp-Project-Hub',
      eventFirstName: 'Project Hub',
      eventLastName: 'TCP',
      eventID: 409,
      eventImg: image1,
      status: 'Closed',
      clicked: false,
    },
    {
      eventTag: 'Kalakriti',
      eventFirstName: 'Kalakriti',
      eventLastName: 'Art Festival',
      eventID: 411,
      eventImg: image2,
      status: 'Closed',
      clicked: false,
    },
    {
      eventTag: 'Web Dev Expo',
      eventFirstName: 'Web Dev',
      eventLastName: 'Workshop',
      eventID: 410,
      eventImg: image3,
      status: 'Upcoming',
      clicked: false,
    },
    {
      eventTag: 'Event_4',
      eventFirstName: 'Sculpting',
      eventLastName: 'Exhibition',
      eventID: 2,
      eventImg: image4,
      status: 'Upcoming',
      clicked: false,
    },
  ],
};

export const eventsSlice = createSlice({
  name: 'events',
  initialState,
  reducers: {
    //  reducers comes here
    openEventPost: (state, action) => {
      state.eventsData.map((option) => {
        option.clicked = option.eventID === action.payload;
      });
    },
    closeEventPosts: (state, action) => {
      state.eventsData.map((option) => {
        option.clicked = false;
      });
    },
  },
  extraReducers: () => {
    //  Extra reducers comes here
  },
});
export const { openEventPost, closeEventPosts } = eventsSlice.actions;
export default eventsSlice.reducer;
